import { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import LoginPage from "./pages/LoginPage/LoginPage";
import ErpLogin from "./pages/LoginPage/ErpLogin.tsx";
import Dashboard from "./pages/Dashboard/Dashboard";
import { ToastContainer } from "react-toastify";
import "../node_modules/edviron-ui-package/dist/output.css";
import LoadAndRender from "./components/LoadAndRender/LoadAndRender.tsx";
import {
  useQuery,
} from "@apollo/client";
import "react-toastify/dist/ReactToastify.css";
import { GET_USER } from "./Qurries.ts";
import ResetPassword from "./pages/LoginPage/ResetPassword.tsx";
import TrusteeLogin from "./pages/LoginPage/TrusteeLogin.tsx";
import {
  buildPayoutsLocalShellUser,
  isPayoutsLocalShellEnabled,
  PAYOUTS_LOCAL_SHELL_KEY,
  shouldSkipMerchantGraphql,
} from "./utils/payoutLocalShell.ts";

const isLocalPayoutsShellActive = () =>
  isPayoutsLocalShellEnabled() &&
  (process.env.REACT_APP_PAYOUTS_LOCAL_SHELL === "true" ||
    localStorage.getItem(PAYOUTS_LOCAL_SHELL_KEY) === "1");

function App() {
  const [user, set_user] = useState(null);
  const skipMerchantGraphql =
    !localStorage.getItem("merchantToken") || shouldSkipMerchantGraphql();

  const { data, refetch } = useQuery(GET_USER, {
    errorPolicy: "ignore",
    skip: skipMerchantGraphql,
  });
  useEffect(() => {
    if (data?.getMerchantQuery || data?.getUserQuery) {
      set_user(data);
      return;
    }
    // Local payouts shell: keep UI usable when Edviron GraphQL is down/unset.
    if (isLocalPayoutsShellActive() && localStorage.getItem("merchantToken")) {
      set_user(buildPayoutsLocalShellUser(localStorage.getItem("merchantToken") || undefined));
    }
  }, [data]);

  // if (loading) return <HomeLoadingScreen />;
  return (
    <LoadAndRender
      promise={async () => {
        const token = localStorage.getItem("merchantToken");

        if (token) {
          if (isLocalPayoutsShellActive()) {
            set_user(buildPayoutsLocalShellUser(token));
            return;
          }
          try {
            const res = await refetch();
            if (res?.data?.getMerchantQuery || res?.data?.getUserQuery) {
              set_user(res.data);
              return;
            }
            throw new Error("merchant query empty");
          } catch (err) {
            console.warn("Edviron GraphQL unavailable:", err?.message || err);
          }
        }
      }}
    >
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<LoginPage user={user} set_user={set_user} />}
          />
          <Route
            path="/erp/partner-logo"
            element={<ErpLogin user={user} set_user={set_user} />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/*" element={<TrusteeLogin />} />
          <Route
            path="*"
            element={<Dashboard user={user} set_user={set_user} />}
          />
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </LoadAndRender>
  );
}

export default App;
